import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import { doc, getDoc, setDoc } from "./firebase-shim";

// MAG_PONTEGGIO_v1 - magazzino del ponteggio aziendale (impostazioni/magazzino_ponteggio)

const TIPI = [
  ["partenza", "Elemento di partenza"],
  ["montante", "Montante"],
  ["corrente", "Corrente"],
  ["traverso_u", "Traverso a U"],
  ["traverso_u_rinf", "Traverso a U rinforzato"],
  ["diagonale", "Diagonale"],
  ["mensola", "Mensola"],
  ["fermaimpalcato", "Fermaimpalcato"],
  ["fermapiede", "Fermapiede"],
  ["impalcato", "Impalcato"],
  ["impalcato_botola", "Impalcato con botola e scala"],
  ["spina", "Spina di sicurezza"],
  ["basetta", "Basetta regolabile"],
  ["basetta_incl", "Basetta inclinabile"],
  ["ancoraggio_tubo", "Tubo di ancoraggio"],
  ["golfare", "Golfare con tassello"],
  ["giunto", "Giunto"],
  ["altro", "Altro"],
];
const nomeTipo = t => (TIPI.find(x => x[0] === t) || [t, t])[1];

const r = (codice, tipo, descrizione, misura, qta, autorizzato = true) =>
  ({ id: codice || (tipo + "_" + misura), codice, tipo, descrizione, misura, qta, peso: "", autorizzato });

const LISTA_0910 = [
  r("2602000N", "partenza", "Elemento di partenza Allround", "", 32),
  r("2603100N", "montante", "Montante acciaio c/spina 1,00 m", "1.00", 17),
  r("2603150N", "montante", "Montante acciaio c/spina 1,50 m", "1.50", 2),
  r("2603200N", "montante", "Montante acciaio c/spina 2,00 m", "2.00", 34),
  r("2603250N", "montante", "Montante acciaio c/spina 2,50 m", "2.50", 2),
  r("2603300N", "montante", "Montante acciaio c/spina 3,00 m", "3.00", 87),
  r("2607073N", "corrente", "Corrente acciaio 0,73 m", "0.73", 115),
  r("2607157N", "corrente", "Corrente acciaio 1,57 m", "1.57", 61),
  r("2607207N", "corrente", "Corrente acciaio 2,07 m", "2.07", 24),
  r("2607257N", "corrente", "Corrente acciaio 2,57 m", "2.57", 95),
  r("2607307N", "corrente", "Corrente acciaio 3,07 m", "3.07", 5),
  r("2613073N", "traverso_u", "Traverso a U acciaio 0,73 m", "0.73", 91),
  r("2624157N", "traverso_u_rinf", "Traverso a U rinforzato 1,57 m", "1.57", 4),
  r("2624257N", "traverso_u_rinf", "Traverso a U rinforzato 2,57 m", "2.57", 4),
  r("2620073N", "diagonale", "Diagonale campata 2,00 x 0,73", "0.73", 6),
  r("2620157N", "diagonale", "Diagonale campata 2,00 x 1,57", "1.57", 8),
  r("2620257N", "diagonale", "Diagonale campata 2,00 x 2,57", "2.57", 10),
  r("2620307N", "diagonale", "Diagonale campata 2,00 x 3,07", "3.07", 1),
  r("2630073N", "mensola", "Mensola 0,73 m", "0.73", 20),
  r("2635073N", "fermaimpalcato", "Fermaimpalcato T8 0,73 m", "0.73", 90),
  r("2660073N", "fermapiede", "Fermapiede legno 0,20 x 0,73", "0.73", 20),
  r("2660157N", "fermapiede", "Fermapiede legno 0,20 x 1,57", "1.57", 20),
  r("2660207N", "fermapiede", "Fermapiede legno 0,20 x 2,07", "2.07", 11),
  r("2660257N", "fermapiede", "Fermapiede legno 0,20 x 2,57", "2.57", 30),
  r("2660307N", "fermapiede", "Fermapiede legno 0,20 x 3,07", "3.07", 2),
  r("3812073N", "impalcato", "Impalcato acciaio T4 0,32 x 0,73", "0.73", 20),
  r("3812157N", "impalcato", "Impalcato acciaio T4 0,32 x 1,57", "1.57", 40),
  r("3812207N", "impalcato", "Impalcato acciaio T4 0,32 x 2,07", "2.07", 20),
  r("3812257N", "impalcato", "Impalcato acciaio T4 0,32 x 2,57", "2.57", 42),
  r("3838257N", "impalcato_botola", "Impalcato robust c/botola e scala 2,57", "2.57", 14),
  r("3838307N", "impalcato_botola", "Impalcato robust c/botola e scala 3,07", "3.07", 1),
  r("4000001N", "spina", "Spina di sicurezza rossa 11 mm", "", 142),
  r("4001060N", "basetta", "Basetta regolabile 0,6 m", "0.60", 28),
  r("4003000N", "basetta_incl", "Basetta regolabile inclinabile 0,6 m", "0.60", 10),
  r("CSC-121E", "ancoraggio_tubo", "Tubo di ancoraggio C.S.C. 121E, 48x2,5, L 50 cm", "0.50", 50, false),
  r("", "golfare", "Golfare con tassello a espansione (omologato)", "", 50),
  r("", "giunto", "Giunto ortogonale (omologato)", "", 50),
];

const cell = { padding: "5px 6px", borderTop: "1px solid rgba(128,128,128,0.25)", fontSize: 13, verticalAlign: "middle" };
const inp = { width: "100%", boxSizing: "border-box", padding: "4px 6px", borderRadius: 5, border: "1px solid rgba(128,128,128,0.4)", background: "rgba(128,128,128,0.08)", color: "inherit", fontSize: 13 };
const num = v => { const n = parseFloat(String(v).replace(",", ".")); return isNaN(n) ? 0 : n; };

export default function MagazzinoPonteggio() {
  const [pezzi, setPezzi] = useState(null);
  const [vuoto, setVuoto] = useState(false);
  const [modificato, setModificato] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [salvatoIl, setSalvatoIl] = useState("");
  const [errore, setErrore] = useState("");
  const [filtro, setFiltro] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const s = await getDoc(doc(db, "impostazioni", "magazzino_ponteggio"));
        const ex = s && (typeof s.exists === "function" ? s.exists() : !!s.exists);
        const d = ex ? s.data() : null;
        if (d && Array.isArray(d.pezzi)) { setPezzi(d.pezzi); setSalvatoIl(d.updatedAt || ""); }
        else { setPezzi([]); setVuoto(true); }
      } catch (e) { setErrore("Errore nel caricamento: " + e.message); setPezzi([]); }
    })();
  }, []);

  const cambia = (i, campo, val) => {
    setPezzi(p => p.map((x, k) => k === i ? { ...x, [campo]: val } : x));
    setModificato(true);
  };
  const togli = i => {
    if (!window.confirm("Togliere \"" + (pezzi[i].descrizione || "pezzo") + "\" dal magazzino?")) return;
    setPezzi(p => p.filter((_, k) => k !== i)); setModificato(true);
  };
  const aggiungi = () => {
    setPezzi(p => [...p, { id: "n" + Date.now(), codice: "", tipo: "altro", descrizione: "", misura: "", qta: 0, peso: "", autorizzato: true }]);
    setModificato(true);
  };
  const caricaLista = () => {
    setPezzi(LISTA_0910.map(x => ({ ...x }))); setVuoto(false); setModificato(true);
  };
  const salva = async () => {
    setSalvando(true); setErrore("");
    try {
      const pulito = pezzi.map(x => ({ ...x, qta: num(x.qta), peso: x.peso === "" ? "" : num(x.peso) }));
      const now = new Date().toISOString();
      await setDoc(doc(db, "impostazioni", "magazzino_ponteggio"), { pezzi: pulito, updatedAt: now });
      setPezzi(pulito); setSalvatoIl(now); setModificato(false);
    } catch (e) { setErrore("Salvataggio non riuscito: " + e.message); }
    finally { setSalvando(false); }
  };

  if (pezzi === null) return <div style={{ padding: "12px 0", fontSize: 13, opacity: 0.7 }}>Carico il magazzino...</div>;

  const f = filtro.trim().toLowerCase();
  const visibili = pezzi.map((x, i) => [x, i]).filter(([x]) => !f || (x.descrizione + " " + x.codice + " " + nomeTipo(x.tipo)).toLowerCase().includes(f));
  const totPezzi = pezzi.reduce((s, x) => s + num(x.qta), 0);
  const totKg = pezzi.reduce((s, x) => s + num(x.qta) * num(x.peso), 0);
  const nonAut = pezzi.filter(x => x.autorizzato === false && num(x.qta) > 0);

  return (
    <div style={{ marginTop: 22, paddingTop: 16, borderTop: "1px solid rgba(128,128,128,0.3)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8, marginBottom: 8 }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 15 }}>🏗️ Magazzino ponteggio</div>
          <div style={{ fontSize: 12, opacity: 0.7 }}>
            {pezzi.length} voci · {totPezzi.toLocaleString("it-IT")} pezzi{totKg > 0 ? " · " + Math.round(totKg).toLocaleString("it-IT") + " kg" : ""}
            {salvatoIl && !modificato ? " · salvato il " + new Date(salvatoIl).toLocaleString("it-IT") : ""}
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <input style={{ ...inp, width: 170 }} placeholder="Cerca pezzo..." value={filtro} onChange={e => setFiltro(e.target.value)} />
          <button className="btn btn-sm" onClick={aggiungi}>➕ Aggiungi pezzo</button>
          <button className="btn btn-primary btn-sm" onClick={salva} disabled={salvando || !modificato}>
            {salvando ? "Salvo..." : modificato ? "💾 Salva magazzino" : "✓ Salvato"}
          </button>
        </div>
      </div>

      {errore && <div style={{ color: "#dc2626", fontSize: 13, marginBottom: 8 }}>{errore}</div>}

      {vuoto && pezzi.length === 0 && (
        <div style={{ padding: 12, border: "1px dashed rgba(128,128,128,0.5)", borderRadius: 8, fontSize: 13, marginBottom: 10 }}>
          Il magazzino è vuoto.{" "}
          <button className="btn btn-sm" onClick={caricaLista}>📋 Carica la lista pezzi del 09/10/2026</button>
          <span style={{ opacity: 0.7 }}> (poi controlla e premi Salva)</span>
        </div>
      )}

      {nonAut.length > 0 && (
        <div style={{ fontSize: 12, color: "#d97706", marginBottom: 8 }}>
          ⚠ {nonAut.length} {nonAut.length === 1 ? "pezzo non compreso" : "pezzi non compresi"} nell'elenco componenti del libretto ({nonAut.map(x => x.descrizione).join(", ")}): nel PIMUS comparirà la riga di verifica.
        </div>
      )}

      {pezzi.length > 0 && (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 760 }}>
            <thead>
              <tr style={{ fontSize: 11, opacity: 0.7, textAlign: "left" }}>
                <th style={{ padding: "4px 6px", width: 100 }}>Codice</th>
                <th style={{ padding: "4px 6px", width: 170 }}>Tipo</th>
                <th style={{ padding: "4px 6px" }}>Descrizione</th>
                <th style={{ padding: "4px 6px", width: 70 }}>Misura m</th>
                <th style={{ padding: "4px 6px", width: 70 }}>Q.tà</th>
                <th style={{ padding: "4px 6px", width: 70 }}>Peso kg</th>
                <th style={{ padding: "4px 6px", width: 70, textAlign: "center" }} title="Compreso nell'elenco componenti del libretto ministeriale">Autoriz.</th>
                <th style={{ padding: "4px 6px", width: 36 }}></th>
              </tr>
            </thead>
            <tbody>
              {visibili.map(([x, i]) => (
                <tr key={x.id || i}>
                  <td style={cell}><input style={inp} value={x.codice} onChange={e => cambia(i, "codice", e.target.value)} /></td>
                  <td style={cell}>
                    <select style={inp} value={x.tipo} onChange={e => cambia(i, "tipo", e.target.value)}>
                      {TIPI.map(([k, n]) => <option key={k} value={k}>{n}</option>)}
                    </select>
                  </td>
                  <td style={cell}><input style={inp} value={x.descrizione} onChange={e => cambia(i, "descrizione", e.target.value)} /></td>
                  <td style={cell}><input style={inp} value={x.misura} onChange={e => cambia(i, "misura", e.target.value)} /></td>
                  <td style={cell}><input style={{ ...inp, textAlign: "right" }} value={x.qta} onChange={e => cambia(i, "qta", e.target.value)} /></td>
                  <td style={cell}><input style={{ ...inp, textAlign: "right" }} value={x.peso} onChange={e => cambia(i, "peso", e.target.value)} /></td>
                  <td style={{ ...cell, textAlign: "center" }}>
                    <input type="checkbox" checked={x.autorizzato !== false} onChange={e => cambia(i, "autorizzato", e.target.checked)} />
                  </td>
                  <td style={{ ...cell, textAlign: "center" }}>
                    <button className="btn btn-sm" title="Togli dal magazzino" onClick={() => togli(i)}>✕</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ fontSize: 11, opacity: 0.6, marginTop: 8 }}>
        Il magazzino si salva con il suo pulsante, separato da "Salva" della sezione. Il peso è facoltativo (serve per i kg da trasportare).
      </div>
    </div>
  );
}
